import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 px-4 bg-navy-800 relative border-t border-navy-700/50" data-id="element-183">
      <div className="max-w-3xl mx-auto" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-185">
          <div className="w-12 h-1 bg-amber-500/50 mx-auto mb-10 rounded-full" data-id="element-186"></div>

          <div className="bg-navy-900/50 p-8 md:p-12 rounded-2xl border border-navy-700/50 shadow-xl" data-id="element-187">
            <p className="text-lg md:text-xl text-cream-100 font-body leading-relaxed mb-6" data-id="element-188">
              En la cultura latina, nos han enseñado que el sacrificio total es
              sinónimo de buena madre. Te dicen que "ya dormirá cuando crezca",
              mientras tú intentas manejar en las autopistas de Estados Unidos
              con el mismo nivel de reflejos que una persona ebria por la falta
              de descanso.
            </p>
            <p className="text-lg md:text-xl text-cream-100 font-body leading-relaxed" data-id="element-189">
              Has intentado de todo: pasearlo en el coche a medianoche, mecerlo
              hasta que te duelen los brazos, o dejarlo en tu cama por
              desesperación, solo para despertarte cada 45 minutos cuando él
              busca el pecho o tu contacto para volver a dormir.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}